export const MODULES = {
	PEDIDOS_SIMULACAO: "Pedidos Simulação",
	PEDIDO_SIMULACAO_LABORATORIOS: "Pedido e Simulação Laboratórios",
	PEDIDOS: "Pedidos",
	PEDIDOS_PROMOCAO: "Pedidos Promoção",
	PEDIDOS_PROMOCAO_DETALHADA: "Pedidos Promoção Detalhada",
	PEDIDOS_VALORES: "Pedidos Valores",
	CONSULTA_REDE: "Consulta Rede",
	GESTAO_LABORATORIOS: "Gestão Laboratórios",
	TRACKING: "Tracking",
	CONECTA_VANTAGENS: "Conecta Vantagens",
	VARILUX_ESPECIALISTA: "Varilux Especialista",
	GESTAO_PAPEIS: "Gestão Papéis",
	MARKETING_CENTER: "Marketing Center",
	ESSILOR_SOLUTIONS: "Essilor Solutions",
	SIMULADOR_TRANSITIONS: "Simulador Transitions",
	CONSULTA_COLABORADOR: "Consulta Colaborador",
	SSO: "SSO",
	PACTO: "Pacto",
	CONSULTA_PRODUTOS_LAB: "Consulta Produtos por Lab",
	CONSULTA_CUPOM: "Consulta Cupom",
	PRODUTOS: "Produtos",
	FINANCEIRO: "Financeiro",
	SUPORTE: "Suporte",
	PRECOS_SERVICOS: "Preços e Serviços",
	ATACADO: "Atacado",
	LEONARDO: "Leonardo",
	DASHBOARD_PEDIDOS: "Dashboard Pedidos",
	ESSILOR_PROMO: "Essilor Promo",
	MY_ESSILOR_LUXOTTICA: "MyEssilorLuxottica",
	MEUS_COLABORADORES: "Meus Colaboradores",
	SCRIPT_SITUACAO_CADASTRAL: "Script Situação Cadastral",
	WEB_PEDIDOS_4_0: "Web Pedidos 4.0",
	GARANTIAS_ESSILOR_LUXOTTICA: "Garantias EssilorLuxottica",
	GERAR_CUPONS: "Gerar Cupons",
	MIDIA_LABS: "Midia LABs",
	LENTE_PRONTA: "Lente Pronta",
	REPONDEUR: "Conecta Responde"
};